import NodeTranslations from "../translations/nodeTranslations";

export default function translatedNodeCode({ formatMessage, code }) {
  return code in NodeTranslations ? formatMessage(NodeTranslations[code]) : `Missing translation code: ${code}`;
}
